var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShareSunInActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "34px",
    viewBox: "0 0 37 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homeowner-mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System-at-a-Glance",
    transform: "translate(-288.000000, -823.000000)",
    fill: "#D1D3D4",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(289.000000, 824.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.14757501,3.29317223 C8.14757501,1.51293484 6.69982077,0.0651806001 4.91958339,0.0651806001 C3.13934601,0.0651806001 1.69159177,1.51293484 1.69159177,3.29317223 C1.69159177,5.07340961 3.13934601,6.52116385 4.91958339,6.52116385 C6.69982077,6.52116385 8.14757501,5.07340961 8.14757501,3.29317223 Z",
    id: "Fill-3092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0775959525,14.9946419 C0.0775959525,15.2173733 0.258363484,15.3981408 0.481094906,15.3981408 L2.90208862,15.3981408 L2.90208862,19.0296314 C2.90208862,19.2523628 3.08285616,19.4331304 3.30558758,19.4331304 L6.5335792,19.4331304 C6.75631062,19.4331304 6.93707816,19.2523628 6.93707816,19.0296314 L6.93707816,15.3981408 L9.35807187,15.3981408 C9.5808033,15.3981408 9.76157083,15.2173733 9.76157083,14.9946419 C9.76157083,10.695764 7.63432435,7.32816176 4.91958339,7.32816176 C2.20484243,7.32816176 0.0775959525,10.695764 0.0775959525,14.9946419 Z",
    id: "Fill-3093"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    opacity: 0.4,
    transform: "translate(15.905993, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1.536400, 0.214165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4297411,6.45598325 C5.20997848,6.45598325 6.65773273,5.00822901 6.65773273,3.22799162 C6.65773273,1.44775424 5.20997848,0 3.4297411,0 C1.64950372,0 0.201749477,1.44775424 0.201749477,3.22799162 C0.201749477,5.00822901 1.64950372,6.45598325 3.4297411,6.45598325",
    id: "Fill-3092"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.124153524,15.1436261 C0.124153524,15.3663575 0.304921055,15.547125 0.527652477,15.547125 L2.9486462,15.547125 L2.9486462,19.1786156 C2.9486462,19.401347 3.12941373,19.5821146 3.35214515,19.5821146 L6.58013677,19.5821146 C6.8028682,19.5821146 6.98363573,19.401347 6.98363573,19.1786156 L6.98363573,15.547125 L9.40462945,15.547125 C9.62736087,15.547125 9.8081284,15.3663575 9.8081284,15.1436261 C9.8081284,10.8447482 7.68088192,7.47714599 4.96614096,7.47714599 C2.2514,7.47714599 0.124153524,10.8447482 0.124153524,15.1436261 Z",
    id: "Fill-3093"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.949737, 2.412645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.11966946,9.46135476 C9.72863803,9.46135476 11.8503468,7.33964596 11.8503468,4.73067738 C11.8503468,2.12170881 9.72863803,0 7.11966946,0 C4.51070088,0 2.38899208,2.12170881 2.38899208,4.73067738 C2.38899208,7.33964596 4.51070088,9.46135476 7.11966946,9.46135476",
    id: "Fill-3092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11966946,10.6440241 C3.14116978,10.6440241 0.0236533869,15.5793033 0.0236533869,21.8793829 C0.0236533869,22.2057996 0.28857132,22.4707176 0.61498806,22.4707176 L4.1629961,22.4707176 L4.1629961,27.7927296 C4.1629961,28.1191464 4.42791403,28.3840643 4.75433077,28.3840643 L9.48500815,28.3840643 C9.81142489,28.3840643 10.0763428,28.1191464 10.0763428,27.7927296 L10.0763428,22.4707176 L13.6243509,22.4707176 C13.9507676,22.4707176 14.2156855,22.2057996 14.2156855,21.8793829 C14.2156855,15.5793033 11.0981691,10.6440241 7.11966946,10.6440241",
    id: "Fill-3093"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    opacity: 0.7,
    transform: "translate(23.689777, 3.722679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.59599712,3.78454191 C9.59599712,1.69736704 7.89863007,-8.20964918e-15 5.81145521,-8.20964918e-15 C3.72428035,-8.20964918e-15 2.02691331,1.69736704 2.02691331,3.78454191 C2.02691331,5.87171677 3.72428035,7.56908381 5.81145521,7.56908381 C7.89863007,7.56908381 9.59599712,5.87171677 9.59599712,3.78454191 Z",
    id: "Fill-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.607710094,8.51521929 C0.346576703,8.51521929 0.134642356,8.72715363 0.134642356,8.98828702 C0.134642356,13.5562291 2.10544255,15.5383829 3.44611652,16.3577362 L3.44611652,22.2341837 C3.44611652,22.4953171 3.65805087,22.7072514 3.91918426,22.7072514 L7.70372617,22.7072514 C7.96485956,22.7072514 8.1767939,22.4953171 8.1767939,22.2341837 L8.1767939,16.3577362 C9.51746787,15.5383829 11.4882681,13.555283 11.4882681,8.98828702 C11.4882681,8.72715363 11.2763337,8.51521929 11.0152003,8.51521929 L0.607710094,8.51521929 Z",
    id: "Fill-13"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShareSunInActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/shareSun_inActive.a08d4ce07edb1d80e297d42d59d9769e.svg";